module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dozDTo/tc-custom/9781607059080.jpg?1712927412331",
      "alt": "This image is the cover for the book Just for You"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Just for You\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Nurture yourself by sewing something that’s just for you You spend all day doing things for everyone else. It’s time to renew your creative energy by sewing something just for yourself. This chic collection of apparel and accessories from the bloggers at sewcanshe.com gives you the perfect way to relax, replenish, and experience the joy of doing what you love. The projects in this book are organized into 12 chapters for the 12 months of the year, so you can sew sweet little projects all year long. Join us in taking the selfish sewing challenge: Sew one thing just for yourself every month. • Spoil yourself with 24 hip, modern purses, totes, skirts, tops, scarves, and other cute clothing and accessories • Contributors include some of Sew Can She’s most popular bloggers: Delia Randall of Delia Creates, Disney Powless of Ruffles and Stuff, Jessica Christian of Craftiness is Not Optional, Katy Dill of No Big Dill • Blog tutorial-style photo instructions make the sewing easy for sewists of all levels")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caroline Fairbanks-Critchfield, Sarah Markos\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0